import Vue from 'vue'

/**
 * Format campaign status
 */
Vue.filter('formatCampaignStatus', function (status) {
  switch (status) {
    case 'ACTIVE':
      return 'Ativo'
    case 'PENDING':
      return 'Pendente'
    case 'FINISHED':
      return 'Encerrado'
    case 'PAUSED':
      return 'Pausado'
    case 'ERROR':
      return 'Erro'
    case 'FAILED':
      return 'Falha na criação'
    case 'DRAFT':
      return 'Rascunho'
    default:
      return status
  }
})

/**
 * Format creative format
 */
Vue.filter('formatCreativeFormat', function (format) {
  switch (format) {
    case 'DISPLAY':
      return 'Display'
    case 'DISPLAY_VIDEO':
      return 'Vídeo'
    case 'NATIVE_DISPLAY':
      return 'Native Display'
    default:
      return format
  }
})

/**
 * Format campaign status
 */
Vue.filter('formatCampaignType', function (type) {
  switch (type) {
    case 'AUDIO':
      return 'Áudio'
    case 'AMAZON_SPONSORED_BRANDS':
      return 'Amazon Ads - SB'
    case 'AMAZON_SPONSORED_DISPLAY':
      return 'Amazon Ads - SD'
    case 'AMAZON_SPONSORED_PRODUCT':
      return 'Amazon Ads - SP'
    case 'PROGRAMMATIC':
      return 'Programática'
    case 'NATIVE':
      return 'Native'
    case 'NATIVE_CONTEXTUAL':
      return 'Native Contextual'
    case 'NATIVE_OPEN':
      return 'Native Open'
    case 'SEARCH':
      return 'Search'
    case 'YOUTUBE':
      return 'YouTube'
    case 'MANUAL':
      return 'Manual'
    case 'META_ADS':
      return 'Meta Ads'
    case 'PUSH':
      return 'Push'
    default:
      return type
  }
})

/**
 * Format credit card brands
 */
Vue.filter('formatCreditCardBrand', function (brand) {
  return brand.toString().toUpperCase()
})

/**
 * Format currency type
 */
Vue.filter('formatCurrencyType', function (type) {
  switch (type) {
    case 'BRL':
      return 'Real'
    case 'EUR':
      return 'Euro'
    case 'USD':
      return 'Dolar'
    default:
      return type
  }
})

/**
 * Format custom targeting type
 */
Vue.filter('formatCustomTargetingType', function (status) {
  switch (status) {
    case 'BLACKLIST':
      return 'Blocklist'
    case 'EMAIL_AUDIENCE':
      return 'Audiência de email'
    case 'SITE_LIST':
      return 'Lista de sites'
    case 'WISHLIST':
      return 'Wishlist'
    default:
      return status
  }
})

/**
 * Format entity names
 */
Vue.filter('formatEntityNames', function (entity) {
  switch (entity) {
    case 'ADVERTISER':
      return 'Anunciante'
    case 'CAMPAIGN':
      return 'Campanha'
    case 'CAMPAIGN_LINE':
      return 'Estratégia'
    case 'CAMPAIGN_PACKAGE':
      return 'Grupo de Campanha'
    case 'CREATIVE':
      return 'Criativo'
    case 'CUSTOM_TARGETING':
      return 'Audiência personalizada'
    case 'USER':
      return 'Usuário'
    case 'ORDER':
      return 'Order'
    case 'INSERTION_ORDER':
      return 'P.I.'
    case 'REPORT':
      return 'Relatório'
    case 'COMPANY':
      return 'Empresa'
    case 'PIXEL':
      return 'Pixel'
    default:
      return entity
  }
})

/**
 * Format insertion order type
 */
Vue.filter('formatInsertionOrderType', function (type) {
  switch (type) {
    case 'FIRST_PURCHASE':
      return 'Primeira Compra'
    case 'RENEWAL':
      return 'Renovação'
    default:
      return type
  }
})

/**
 * Format nfse approval status
 */
Vue.filter('formatNFSeApprovalStatus', function (status) {
  switch (status) {
    case null:
      return 'Pendente'
    case 1:
    case true:
      return 'Aprovado'
    case 0:
    case false:
      return 'Recusado'
    default:
      return status
  }
})

/**
 * Format nfse status
 */
Vue.filter('formatNFSeStatus', function (status) {
  switch (status) {
    case 'ISSUED':
      return 'Emitido'
    case 'ERROR':
      return 'Erro na emissão'
    case 'REJECTED':
      return 'Rejeitado'
    case 'CANCELED':
      return 'Cancelado'
    case 'PENDING':
      return 'Pendente'
    case 'CREATED':
      return 'Criado'
    case 'WAITING':
      return 'Aguardando emissão'
    default:
      return status
  }
})

/**
 * Format objectives
 */
Vue.filter('formatObjective', function (objective) {
  switch (objective) {
    case 'IMPRESSION':
      return 'Impressão'
    case 'CONVERSION':
      return 'Conversão'
    case 'RETARGETING':
      return 'Retargeting'
    default:
      return objective
  }
})

/**
 * Format order claim type
 */
Vue.filter('formatOrderClaimType', function (format) {
  switch (format) {
    case 'FIRST_PURCHASE':
      return 'Primeira Compra'
    case 'RENEWAL':
      return 'Renovação'
    default:
      return format
  }
})

/**
 * Format order claim responsible profile
 */
Vue.filter('formatOrderClaimResponsibleProfile', function (format) {
  switch (format) {
    case 'AE':
      return 'Executivo de Vendas'
    case 'CS':
      return 'Customer Success'
    case 'SDR':
      return 'SDR'
    default:
      return format
  }
})

/**
 * Format payment
 */
Vue.filter('formatPaymentMethod', function (method) {
  switch (method) {
    case 'CREDIT_CARD':
      return 'Cartão de Crédito'
    case 'BOLETO':
      return 'Boleto Bancário'
    case 'PIX':
      return 'PIX'
    case 'DEPOSIT':
      return 'Depósito'
    default:
      return method
  }
})

/**
 * Format payment status
 */
Vue.filter('formatPaymentStatus', function (status) {
  switch (status) {
    case 'PAID':
      return 'Pago'
    case 'PENDING':
      return 'Pendente cliente'
    case 'PROCESSING':
      return 'Processando'
    case 'AUTHORIZED':
      return 'Autorizado'
    case 'REFUNDED':
      return 'Estornado'
    case 'WAITING_PAYMENT':
      return 'Aguardando pagamento'
    case 'PENDING_REFUND':
      return 'Aguardando estorno'
    case 'REFUSED':
      return 'Recusado'
    case 'CHARGEDBACK':
      return 'Chargeback'
    case 'EXPIRED':
      return 'Expirado'
    case 'CANCELED':
      return 'Cancelado'
    default:
      return status
  }
})

/**
 * Format status
 */
Vue.filter('formatStatus', function (status) {
  switch (status) {
    case 'ACTIVE':
      return 'Ativo'
    case 'AUDIO':
      return 'Áudio'
    case 'INACTIVE':
      return 'Desativado'
    case 'PENDING':
      return 'Pendente'
    case 'FINISHED':
      return 'Encerrado'
    case 'PAUSED':
      return 'Pausado'
    case 'ERROR':
      return 'Erro'
    case 'FAILED':
      return 'Falha na criação'
    case 'DRAFT':
      return 'Rascunho'
    default:
      return status
  }
})

/**
 * Format user roles
 */
Vue.filter('formatUserRole', function (role) {
  switch (role) {
    case 'administrator':
      return 'Administrador'
    case 'user-manager':
      return 'Usuário Administrador'
    case 'user':
      return 'Usuário'
  }
})

/**
 * Format wallet status to sign
 */
Vue.filter('formatWalletTypeToSignal', function (status) {
  switch (status) {
    case 'CREDIT':
      return '+'
    case 'FAILED_TRANSFER_FUND':
      return '+'
    case 'DEBIT':
      return '-'
    case 'CHARGEBACK':
      return '-'
    case 'REFUND':
      return '-'
    case 'CHECKOUT':
      return '-'
  }
})

/**
 * Format wallet status to sign
 */
Vue.filter('formatWatcherStatus', function (status) {
  switch (status) {
    case 'LOW':
      return 'Saudável'
    case 'MEDIUM':
      return 'Atenção'
    case 'HIGH':
      return 'Crítico'
    default:
      return status
  }
})

/**
 * Format claim status
 */
Vue.filter('formatClaimStatus', function (status) {
  switch (status) {
    case 'PENDING':
      return 'Pendente'
    case 'APPROVED':
      return 'Aprovado'
    case 'REFUSED':
      return 'Recusado'
  }
})
